// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","name":"欢迎页","hideInMenu":true,"parentId":"@@/global-layout","id":"1"},"2":{"path":"/login","name":"登录","layout":false,"id":"2"},"3":{"path":"/leads","name":"线索","parentId":"@@/global-layout","id":"3"},"4":{"path":"/survey","name":"问卷","parentId":"@@/global-layout","id":"4"},"5":{"path":"/data","name":"数据","parentId":"@@/global-layout","id":"5"},"@@/global-layout":{"id":"@@/global-layout","path":"/","parentId":"ant-design-pro-layout","isLayout":true},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__welcome__index" */'@/pages/welcome/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__login__index" */'@/pages/login/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__leads__index" */'@/pages/leads/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__survey__index" */'@/pages/survey/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__data__index" */'@/pages/data/index.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/layouts/index.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/var/lib/jenkins/sit-workspace/workspace/prod-mxc-school-crm/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
